<div class="d-flex flex-column h-100 position-relative" style="min-width: 1150px;">
  <div class="kt-portlet__body bold">
    <ng-container *ngFor="let year of helper.getAllYears(item.years); let ix = index">
      <div class="mb-2 d-flex" style="width: 890px;">
        <div class="line-label"></div>
        <span class="based-on">Based on</span>
        <span class="px-3" ngbDropdown container="body">
          <span class="cursor-pointer hide" ngbDropdownToggle>{{year}}<i class="fa fa-angle-down ml-2"></i></span>
          <div ngbDropdownMenu>
            <button ngbDropdownItem *ngFor="let newYear of helper.getAllBasedOnYears()"
              (click)="helper.changeBasedOnYear(item, year, newYear)"
              [disabled]="item.years.has(newYear) ? true : null">{{newYear}}</button>
          </div>
        </span>
        <button class="btn btn-xxs btn-outline-secondary" *ngIf="ix == 0 && helper.canAddYear(item.years)"
          (click)="helper.addBasedOnYear(item)">+</button>
        <button class="btn btn-xxs btn-outline-danger" *ngIf="ix > 0" (click)="helper.removeBasedOnYear(item, year)">-</button>
        <div class="ml-auto" *ngIf="ix == 0">
          <span class="kt-label-font-color-1">Profit per piece:</span>
          <span class="strong"> {{(item.data.profit / helper.last30DaysOrders(item)) || 0 | currency}}</span>
          <span class="kt-label-font-color-1 ml-3">Profit last 30 days:</span>
          <span class="strong">{{item.data.profit || 0 | currency}}</span>
        </div>
      </div>
      <div class="mb-1">
        <div class="line-label kt-margin-t-30">
          <div class="p-1 text-nowrap">Sold</div>
          <div class="p-1">Stock</div>
        </div>
        <div class="d-flex left">
          <div class="reorder-month" *ngFor="let monthData of item.years.get(year)" #p="ngbPopover"
            [ngbPopover]="helper.popoverMessage" container="body" placement="top" triggers="manual" popoverClass="popover-danger"
            [class.selected]="monthData.selected" [class.left-selected]="monthData.leftSelected"
            (click)="helper.selectMonth(item, monthData, p)"
            [ngClass]="helper.disabledMonth(monthData.date) ? 'disabled' : 'cursor-pointer'">
            <div class="border-bottom p-1 strong">{{monthData.date | date:'MMM':'UTC'}}</div>
            <div class="p-1">{{helper.showQuantity(item, helper.sumOrders(monthData)) || 0 | number}}</div>
            <table>
              <tr>
                <td width="60%">
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-grey" [style.width.%]="helper.inStockAvg(monthData) * 100"></div>
                  </div>
                </td>
                <td>
                  <div class="small-text">{{helper.inStockAvg(monthData) || 0 | percent}}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="d-flex ml-2 right" *ngIf="ix == 0">
          <div class="reorder-month cursor-pointer" *ngFor="let latest of item.latest" #p="ngbPopover"
            [ngbPopover]="helper.popoverMessage" container="body" placement="top" triggers="manual" popoverClass="popover-danger"
            (click)="helper.selectMonth(item, latest, p)" [class.selected]="latest.selected"
            [class.left-selected]="latest.leftSelected">
            <div class="border-bottom p-1 strong">{{latest.days}} Days</div>
            <div class="p-1">{{helper.showQuantity(item, helper.sumOrders(latest)) || 0 | number}}</div>
            <table>
              <tr>
                <td width="60%">
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-grey" [style.width.%]="helper.inStockAvg(latest) * 100"></div>
                  </div>
                </td>
                <td>
                  <div class="small-text">{{helper.inStockAvg(latest) || 0 | percent}}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngFor="let year of helper.getAllYears(item.orderForYears, false); let ix = index">
      <div class="mb-2 mt-1 d-flex" style="width: 890px" [class.mt-3]="ix == 0">
        <div class="line-label"></div>
        <span class="based-on">Reorder for</span>
        <span class="px-3" ngbDropdown container="body">
          <span class="cursor-pointer hide" ngbDropdownToggle>{{year}}<i class="fa fa-angle-down ml-2"></i></span>
          <div ngbDropdownMenu>
            <button ngbDropdownItem *ngFor="let newYear of helper.getAllOrderForYears()"
              (click)="helper.changeOrderForYear(item, year, newYear)"
              [disabled]="item.orderForYears.has(newYear) ? true : null">{{newYear}}</button>
          </div>
        </span>
        <button class="btn btn-xxs btn-outline-secondary" *ngIf="ix == 0 && helper.canAddYear(item.orderForYears)"
          (click)="helper.addOrderForYear(item)">+</button>
        <button class="btn btn-xxs btn-outline-danger" *ngIf="ix > 0" (click)="helper.removeOrderForYear(item, year)">-</button>
        <div class="ml-auto" *ngIf="ix == 0">
          <span class="kt-label-font-color-1 ml-3">Est. Profit:</span>
          <span class="strong"> {{((item.data.profit / helper.last30DaysOrders(item)) * item.totalReorder) || 0 | currency}}</span>
        </div>
      </div>
      <div class="mb-2 mt-1">
        <div class="line-label mt-2">
          <div class="p-1 mt-5">
            <span ngbDropdown container="body" *ngIf="helper.main">
              <span class="cursor-pointer hide" ngbDropdownToggle>
                {{helper.showPacks ? 'Packs' : 'Units'}}<i class="fa fa-angle-down ml-2"></i></span>
              <div ngbDropdownMenu>
                <button ngbDropdownItem (click)="helper.showPacks = false">Units</button>
                <button ngbDropdownItem (click)="helper.showPacks = true">Packs</button>
              </div>
            </span>
            <ng-container *ngIf="!helper.main">
              {{helper.showPacks ? 'Packs' : 'Units'}}
            </ng-container>
          </div>
        </div>
        <div class="reorder-for left d-flex position-relative">
          <div *ngFor="let month of helper.allMonths">
            <div class="text-center strong">{{year + month | date:'MMM'}}</div>
            <button (click)="helper.selectOrderForMonth(item, year + month)"
              [ngClass]="'btn-' + (helper.disableReorderMonth(item, year + month) ? '' : 'outline-') + 'secondary'"
              class="btn px-0 kt-label-font-color-1" [disabled]="helper.disableReorderMonth(item, year + month)"
              [class.selected]="helper.isOrderForMonthSelected(item, year + month)
                && helper.getAvailableDays(item, year + month)">
              {{ helper.isOrderForMonthSelected(item, year + month) ?
              (helper.totalOrders(item, item.formGroup.value.outOfStock, item.formGroup.value.buyBox,
              helper.getAvailableDays(item, year + month), false) | number:'1.0-0') : helper.getMonthDays(year + month) + ' days' }}
              <div *ngIf="helper.isOrderForMonthSelected(item, year + month)">
                <span class="kt-font-brand small-text">{{helper.getAvailableDays(item, year + month)}} days</span>
              </div>
            </button>
          </div>
        </div>
        <div class="reorder-for ml-2 right">
        </div>
        <div class="reorder-for ml-2 right" *ngIf="ix == 0" [formGroup]="item.formGroup">
          <input type="number" class="form-control" formControlName="totalDays" style="width: 70px">
          <div class="right ml-2"
            [ngClass]="item.formGroup.value.totalDays != (item.data.orderFor || item.totalOrderFor) ? 'pt-1' : 'pt-2'">
            <div>Total days of supply</div>
            <div *ngIf="item.formGroup.value.totalDays != (item.data.orderFor || item.totalOrderFor)"
              (click)="item.formGroup.controls.totalDays.setValue(item.data.orderFor || item.totalOrderFor)"
              class="kt-font-brand small-text cursor-pointer">Reset to selection</div>
          </div>
        </div>
      </div>
      <advanced-reorder-slider (monthSelected)="helper.selectOrderForMonth(item, $event)"
        (sliding)="helper.sliderMouseDown($event)" [year]="year" [item]="item" [helper]="helper">
      </advanced-reorder-slider>
    </ng-container>
  </div>
  <div class="kt-portlet__body bold border-top mt-auto">
    <div [formGroup]="item.formGroup">
      <div class="d-flex align-items-center h-100">
        <div class="kt-padding-r-10">Settings</div>
        <div class="d-flex h-100 w-100">
          <i class="fa-solid fa-warehouse p-2" [class.disabled]="!item.formGroup.value.minusInventory"></i>
          <i class="fa-solid fa-shop-lock p-2" [class.disabled]="!item.formGroup.value.minusStoreInventory"></i>
          <i class="fa-solid fa-shop p-2" [class.disabled]="!item.formGroup.value.minusOverstockedStoreInventory"></i>
          <i class="fa-solid fa-cart-arrow-down p-2" [class.disabled]="!item.formGroup.value.minusPOs"></i>
          <i class="fa-solid fa-chart-simple p-2" [class.disabled]="!item.formGroup.value.outOfStock"></i>
          <i class="fa-solid fa-box p-2" [class.disabled]="!item.formGroup.value.buyBox"></i>
          <span class="ml-auto mt-1">{{ helper.getRuleName(item.formGroup.value.reorderRuleId) || 'Custom' }}</span>
        </div>
      </div>
      <ng-template #ruleModal let-modal>
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title">SAVE SETTINGS AS RULE</h4>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="modal-body">
                <div class="p-3">
                  <label>Reorder Rule Name</label>
                  <input #ruleName class="form-control">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">CLOSE</button>
          <button type="button" (click)="helper.saveItemSettingsAsRule(item, ruleName.value)" class="btn btn-brand">SAVE</button>
        </div>
      </ng-template>
    </div>
  </div>
</div>